import { AboveTheFoldAutocomplete } from "modules/sections/AboveTheFold";
import type { ReactStoryblokComponent } from "types/storyblok";
import type { AboveTheFoldAutocompleteProps } from "modules/sections/AboveTheFold";

const AboveTheFoldAutocompleteSectionAdapter = ({
  blok: { srcMobile, srcDesktop, title, subtitle, alt, buttonText },
  sbEditable,
}: ReactStoryblokComponent<AboveTheFoldAutocompleteProps>) => (
  <AboveTheFoldAutocomplete
    srcDesktop={srcDesktop}
    alt={alt}
    srcMobile={srcMobile}
    title={title}
    subtitle={subtitle}
    buttonText={buttonText}
    sbEditable={sbEditable}
  />
);
export default AboveTheFoldAutocompleteSectionAdapter;
